export default __webpack_public_path__ + "static/media/tag1Icon.e6dd88b2.svg";